const ContentsMenuTypes = {
    defaultContents: {
        id: "defaultContents",
        group: "General",
        path: "/templates",
        label: "Users",
        tabs: [],
        implemented: true,
    },
    welcomeMessages: {
        id: "welcomeMessages",
        group: "General",
        path: "/system-messages",
        label: "Roles",
        tabs: [],
        implemented: true,
    },
    catalogCategories: {
        id: "catalogCategories",
        group: "General",
        path: "/catalog",
        label: "Departments",
        tabs: [],
        implemented: true,
    },
    bannedWords: {
        id: "bannedWords",
        group: "General",
        path: "/forbidden-inputs",
        label: "Banned Visitors",
        tabs: [],
        implemented: true, // if you show item in menu set to true
    },
    tags: {
        id: "tags",
        group: "General",
        path: "/tags",
        label: "Banned Visitors",
        tabs: [],
        implemented: true, // if you show item in menu set to true
    },
};

Object.keys(ContentsMenuTypes).forEach((key) => {
    if (!ContentsMenuTypes[key].implemented) {
        delete ContentsMenuTypes[key];
    }
});

export default ContentsMenuTypes;
